import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RequestInvite } from '../../components/RequestInvite';
import { logEvent, logPageView } from '../../models/Analytics';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	isPersonalPlan?: boolean;
	showRequestInvitePopup?: boolean;
}

export class Pricing extends React.Component<IProps, IState> {
	public state: IState = {
		isPersonalPlan: false,
		showRequestInvitePopup: false,
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Pricing';
		logPageView('Pricing');
	}

	private personalPlanClick = () => {
		logEvent('Pricing', 'SignUp-ShowForm-Personal', null);
		this.setState({ showRequestInvitePopup: true, isPersonalPlan: true });
	}

	private businessPlanClick = () => {
		logEvent('Pricing', 'SignUp-ShowForm-Business', null);
		this.setState({ showRequestInvitePopup: true, isPersonalPlan: false });
	}

	private requestInviteClose = () => {
		this.setState({ showRequestInvitePopup: false });
	}

	private formatSignupForm = () => {
		if (this.state.showRequestInvitePopup) {
			return (<RequestInvite showPopup={ true } onClose={ this.requestInviteClose } isPersonalPlan={ this.state.isPersonalPlan } />);
		} else {
			return '';
		}
	}

	public render() {
		return (
			<MainContainer activeSection='pricing'>
				{ this.formatSignupForm() }
				<div className='pricing-outerContainer'>
					<div className='pricing-tableContainer'>
						<h1 className='pricing-Headline'>
							Personal &amp; Business Plans
						</h1>
						<div className='pricing-table'>
							<div className='pricing-table-planContainer'>
								<div className='personalGraphic' />
								<div className='pricing-table-planName'>
									Personal
								</div>
								<div className='pricing-planPrice'>
									Free
								</div>
								<div className='pricingSmallerText'>&nbsp;</div>
								<div className='pricing-buttonContainer'>
									<span className='cta-button' onClick={ this.personalPlanClick }>
										Sign Up
									</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>1 user only</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>
										Supports Gmail, Hotmail,
										Google Apps and Office 365 email accounts.
									</span>
								</div>
								<div className='pricing-planGridItem featureGrid-enhancement'>
									<span className='featureGap'>No contact enhancement</span>
								</div>
								<div className='pricing-planGridItem featureGrid-support'>
									<span className='featureGap'>No support</span>
								</div>
								<div className='pricing-planGridItem pricing-planGridBottom'>
									<span className='featureGap'>No reporting or analytics</span>
								</div>
							</div>
							<div className='pricing-divider' />
							<div className='pricing-table-planContainer'>
								<div className='professionalGraphic' />
								<div className='pricing-table-planName'>
									Business
								</div>
								<div className='pricing-planPrice'>
									$150<span className='pricingSmallerText'>/month</span>
								</div>
								<div className='pricingSmallerText'>(billed annually)</div>
								<div className='pricing-buttonContainer'>
									<span className='cta-button' onClick={ this.businessPlanClick }>
										Free Trial
									</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>Includes 5 users</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>Supports Gmail, Google Apps, Office 365, MS Exchange Server, and IMAP.</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>
										Contacts are automatically enhanced with profile pictures, social media
										profile information, company info, bio, and more.
									</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>
										Live onboarding, training and support via email and telephone.
									</span>
								</div>
								<div className='pricing-planGridItem pricing-planGridBottom'>
									<span>Robust reporting on companies and contacts</span>
								</div>
							</div>
							<div className='pricing-divider' />
							<div className='pricing-table-planContainer'>
								<div className='businessPlusGraphic' />
								<div className='pricing-table-planName'>
									Business Plus
								</div>
								<div className='pricing-planPrice'>
									$199<span className='pricingSmallerText'>/month</span>
								</div>
								<div className='pricingSmallerText'>(billed annually)</div>
								<div className='pricing-buttonContainer'>
									<span className='cta-button' onClick={ this.businessPlanClick }>
										Free Trial
									</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>Includes 5 users</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>Supports Gmail, Google Apps, Office 365, MS Exchange Server, and IMAP.</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>
										Contacts are automatically enhanced with profile pictures, social media
										profile information, company info, bio, and more.
									</span>
								</div>
								<div className='pricing-planGridItem'>
									<span>
										Live onboarding, training and support plus a <strong>marketing coach</strong> to help you write emails.
									</span>
								</div>
								<div className='pricing-planGridItem pricing-planGridBottom'>
									<span>Robust reporting on companies and contacts</span>
								</div>
							</div>
						</div>
					</div>
					<div className='pricing-quotesContainer'>
						<div className='pricing-quote'>
							<q>This is the first software I'm actually <strong>excited</strong> to use.</q>
						</div>
						<div className='pricing-quoteAuthor'>
							&mdash; Josh St. John, VP Strategic Partnerships &amp; Channels at Brooks Bell
						</div>
					</div>
				</div>
			</MainContainer>
		);
	}
}
